import { ActionBanner } from './ActionBanner';
import { presentDependencyMessage } from '../lib/settingsPresentation';

export function SettingsDependencyBanner({
  errors = [],
  warnings = [],
}: {
  errors?: string[];
  warnings?: string[];
}) {
  if (errors.length === 0 && warnings.length === 0) {
    return null;
  }

  return (
    <div className="admin-stack admin-stack--tight">
      {errors.length > 0 ? (
        <ActionBanner tone="critical" title="Перед застосуванням треба виправити">
          <ul className="admin-list">
            {errors.map((error) => <li key={error}>{presentDependencyMessage(error)}</li>)}
          </ul>
        </ActionBanner>
      ) : null}
      {warnings.length > 0 ? (
        <ActionBanner tone="warning" title="Варто перевірити перед підтвердженням">
          <ul className="admin-list">
            {warnings.map((warning) => <li key={warning}>{presentDependencyMessage(warning)}</li>)}
          </ul>
        </ActionBanner>
      ) : null}
    </div>
  );
}
